/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon32Regular = forwardRef('ShareNetworkIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4 8a5 5 0 1 1 1.233 3.288l-5.858 3.225c.146.47.225.97.225 1.487a5 5 0 0 1-.225 1.487l5.858 3.225a5 5 0 1 1-.989 1.739l-5.834-3.213a5 5 0 1 1 0-6.477l5.835-3.212A4.996 4.996 0 0 1 17.4 8Zm5-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM8 13a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm11.4 11a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z" })));
});
